import React from 'react'
import PropTypes from 'prop-types'
import styles from './nav.module.css'
import { Link } from 'gatsby'
import { Affiliates } from '../model/affiliates'

const style = {
  color: '#ffffff',
  fontWeight: 300,
  textDecoration: 'none',
}

const activeStyle = {
  color: '#ffffff',
  fontWeight: 400,
  textDecoration: 'none',
  borderBottom: '3px solid #00CDA8',
}

const ListLink = (props) => (
  <li className={styles.listLink}>
    <Link to={props.to} style={style} activeStyle={activeStyle}>
      {props.children}
    </Link>
  </li>
)

ListLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired,
}

const Nav = () => (
  <div className={styles.navContainer}>
    <ul className={styles.nav}>
      <ListLink to="/">Energy</ListLink>
      {/* eslint-disable-next-line */}
      <p className={styles.externalLink}>
        <a target="_blank" href={Affiliates.SwitchPal.Payments.Nav}>
          Card Payment Machines
        </a>
      </p>
      {/* <ListLink to="/news">News</ListLink>
      <ListLink to="/about">About Us</ListLink> */}
    </ul>
  </div>
)

export default Nav
